export const SUID = document.querySelector('#suid')